import { apiHolder as api, apis, } from 'api';
import get from 'lodash/get';
import { createAsyncThunk, createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { AttachmentActions, MailActions } from '../createStore';
import { getIn18Text } from 'api';
const diskApi = api.api.requireLogicalApi(apis.netStorageImpl);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const MaxReqNum = 5;
let reqNum = 0;
let getNormalAttSt = null;
const InitialRootInfo = {
    ent: null,
    personal: null,
};
const InitialTabMsgs = {
    personal: {
        isLocked: false,
        page: 1,
        list: [],
        totalCount: 0,
    },
    ent: {
        page: 1,
        list: [],
        totalCount: 0,
    },
    normalAtt: {
        normalAttReady: false,
        page: 1,
        list: [],
        totalCount: 0,
    },
    cloudAtt: {
        page: 1,
        list: [],
        totalCount: 0,
    },
};
const InitialState = {
    rootInfo: InitialRootInfo,
    listLoading: false,
    diskModalVisible: false,
    currentType: 'personal',
    selectedRows: [],
    failMsgs: null,
    tabMsgs: InitialTabMsgs,
    curDirId: null,
};
const selectedRows = (state) => state.diskAttReducer.selectedRows;
export const selectedTotalSizeOver100M = createDraftSafeSelector(selectedRows, files => {
    const totalSize = files.reduce((acc, item) => acc + (item === null || item === void 0 ? void 0 : item.size), 0);
    return totalSize / 1024 / 1024 > 100;
});
export const doGetRootInfoAsync = createAsyncThunk('DiskReducer/doGetRootInfoAsync', async (_, { dispatch }) => {
    try {
        dispatch(diskSlice.actions.doSetListLoading(true));
        const isLocked = await diskApi.isLockEnabledUsingGET();
        dispatch(diskSlice.actions.doSetPersonalLock(isLocked));
        const result = await Promise.allSettled([diskApi.doGetNSFolderInfo({ type: 'personal' }), diskApi.doGetNSFolderInfo({ type: 'ent' })]);
        dispatch(diskSlice.actions.doSetListLoading(false));
        const _result = result.reduce((acc, item, index) => {
            const type = index === 0 ? 'personal' : 'ent';
            if (item.status === 'fulfilled') {
                acc[type] = item.value;
            }
            else {
                acc[type] = null;
            }
            return acc;
        }, {});
        dispatch(diskSlice.actions.doSetRootInfo(_result));
    }
    catch (error) {
        dispatch(diskSlice.actions.doSetListLoading(true));
        console.log('获取网盘根目录失败', error);
    }
});
export const doGetAttsAsync = createAsyncThunk('DiskReducer/doGetAttsAsync', async (param, { getState, dispatch }) => {
    var _a;
    try {
        dispatch(diskSlice.actions.doSetListLoading(true));
        dispatch(diskSlice.actions.doSetFailMsgs(null));
        const { tabMsgs, curDirId } = getState().diskAttReducer;
        const { type, init } = param;
        const curPage = init ? 1 : tabMsgs[type].page;
        if (init) {
            dispatch(diskSlice.actions.doUpdateTabMsg({
                tab: type,
                val: InitialState.tabMsgs[type],
            }));
        }
        if (type === 'normalAtt') {
            const { success, list: normalAtts, total = 0, notReady, } = await mailApi.listAttachments({
                order: 'date',
                desc: true,
                start: (curPage - 1) * 10,
                limit: 10,
                returnTotal: true,
                skipLockedFolders: true,
            });
            if (success) {
                if (success && notReady) {
                    if (reqNum > MaxReqNum) {
                        dispatch(diskSlice.actions.doSetListLoading(false));
                        getNormalAttSt && clearTimeout(getNormalAttSt);
                        message.error({ content: getIn18Text('QINGQIUSHIBAI') });
                        dispatch(diskSlice.actions.doUpdateTabMsg({
                            tab: 'normalAtt',
                            val: {
                                page: 1,
                                totalCount: 0,
                                list: [],
                                normalAttReady: true,
                            },
                        }));
                        return;
                    }
                    getNormalAttSt = setTimeout(() => {
                        reqNum += 1;
                        dispatch(doGetAttsAsync(param));
                    }, 2000);
                    dispatch(diskSlice.actions.doUpdateTabMsg({
                        tab: 'normalAtt',
                        val: {
                            page: 1,
                            totalCount: 0,
                            list: [],
                            normalAttReady: false,
                        },
                    }));
                    return;
                }
                dispatch(diskSlice.actions.doSetListLoading(false));
                const managedList = (_a = (normalAtts || [])) === null || _a === void 0 ? void 0 : _a.map(l => (Object.assign(Object.assign({}, l), { name: l === null || l === void 0 ? void 0 : l.attn, size: l === null || l === void 0 ? void 0 : l.attsize, updateTime: l === null || l === void 0 ? void 0 : l.sentDate, rowId: `${l === null || l === void 0 ? void 0 : l.id}__${l === null || l === void 0 ? void 0 : l.partId}` })));
                dispatch(diskSlice.actions.doUpdateTabMsg({
                    tab: 'normalAtt',
                    val: {
                        page: (managedList === null || managedList === void 0 ? void 0 : managedList.length) ? curPage + 1 : curPage,
                        totalCount: total,
                        list: init ? managedList : [...tabMsgs['normalAtt'].list, ...managedList],
                        normalAttReady: true,
                    },
                }));
            }
            return;
        }
        if (type === 'cloudAtt') {
            const { cloudAttachments = [], totalCount = -1 } = await diskApi.getCloudAttList({
                pageSize: 10,
                page: curPage,
            });
            dispatch(diskSlice.actions.doSetListLoading(false));
            const managedList = cloudAttachments === null || cloudAttachments === void 0 ? void 0 : cloudAttachments.map(l => (Object.assign(Object.assign({}, l), { name: l === null || l === void 0 ? void 0 : l.fileName, size: l === null || l === void 0 ? void 0 : l.fileSize, updateTime: l === null || l === void 0 ? void 0 : l.updateTime, rowId: l === null || l === void 0 ? void 0 : l.identity })));
            dispatch(diskSlice.actions.doUpdateTabMsg({
                tab: 'cloudAtt',
                val: {
                    page: curPage + 1,
                    totalCount,
                    list: init ? managedList : [...tabMsgs['cloudAtt'].list, ...managedList],
                },
            }));
            return;
        }
        if (['personal', 'ent'.includes(type)]) {
            const { init } = param;
            if (!curDirId)
                return;
            if (type === 'personal' && tabMsgs['personal'].isLocked) {
                dispatch(diskSlice.actions.doSetListLoading(false));
                return;
            }
            const { dirList, fileList, fileTotalCount = -1, dirTotalCount = -1, } = await diskApi.doListNSContent(Object.assign(Object.assign({}, param), { dirId: curDirId, sort: 'createTime', pageSize: 10, needAuthorityInfo: true, page: curPage }));
            dispatch(diskSlice.actions.doSetListLoading(false));
            const managedList = [...dirList, ...fileList].map(item => {
                var _a, _b;
                return (Object.assign(Object.assign({}, item), { rowId: item.id, size: ((_a = item) === null || _a === void 0 ? void 0 : _a.totalSize) || ((_b = item) === null || _b === void 0 ? void 0 : _b.size) || 0 }));
            });
            dispatch(diskSlice.actions.doUpdateTabMsg({
                tab: type,
                val: {
                    page: curPage + 1,
                    totalCount: fileTotalCount + dirTotalCount,
                    list: init ? managedList : [...tabMsgs[type].list, ...managedList],
                },
            }));
            return;
        }
    }
    catch (error) {
        dispatch(diskSlice.actions.doSetListLoading(false));
        dispatch(diskSlice.actions.doSetFailMsgs({
            failIntro: error === 'NETWORK.ERR.TIMEOUT' ? getIn18Text('WUWANGLUO\uFF0CQING') : getIn18Text('JIAZAISHIBAI\uFF0C'),
            failParams: Object.assign({}, param),
        }));
        return;
    }
});
export const doAddDiskAttachment = createAsyncThunk('DiskReducer/doAddDiskAttachment', async (param, { getState, dispatch }) => {
    var _a, _b, _c, _d;
    try {
        dispatch(diskSlice.actions.doSetListLoading(true));
        const { files, addType, mailId } = param;
        const rootState = getState();
        const diskType = rootState.diskAttReducer.currentType;
        const currentMail = rootState.mailReducer.currentMail;
        const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
        const selectedRows = rootState.diskAttReducer.selectedRows;
        const currentAttachments = rootState.attachmentReducer.attachments.filter(at => at.mailId === mailId);
        const fileIds = files.map(f => f === null || f === void 0 ? void 0 : f.id);
        const isPersonal = diskType === 'personal';
        const addCloudAttachments = async (fileIds, _account) => diskApi[isPersonal ? 'doAddAttachmentPersonalAsCloud' : 'doAddAttachmentEntAsCloud'](fileIds, _account);
        const addNormalAttachments = async (fileIds, _account) => diskApi[isPersonal ? 'doAddAttachmentPersonalAsNormal' : 'doAddAttachmentEntAsNormal'](fileIds, _account);
        const over5G = files.some(file => (file === null || file === void 0 ? void 0 : file.size) / 1024 / 1024 / 1024 > 5);
        let attachments = [];
        if (over5G) {
            message.warn(getIn18Text('TIANJIASHIBAI\uFF0C11'));
            return false;
        }
        if (['personal', 'ent'].includes(diskType)) {
            let res = [];
            if (addType === 'normal') {
                res = await addNormalAttachments(fileIds, '');
                attachments = (_a = res
                    .map(({ fileName, fileUrl, isCloud, fileSize, expired, id }) => ({
                    id: id,
                    expired,
                    fileName,
                    fileSize,
                    type: 'netUrl',
                    fileUrl,
                    isCloud,
                    downloadContentId: fileUrl,
                    downloadId: fileUrl,
                }))) === null || _a === void 0 ? void 0 : _a.filter(n => {
                    const target = currentAttachments.find(c => c.id === n.id);
                    return !target;
                });
            }
            if (addType === 'cloud') {
                res = await addCloudAttachments(fileIds);
                attachments = (_b = res
                    .map(({ fileName, fileUrl, isCloud, fileSize, expired, identity }) => ({
                    id: identity,
                    expired,
                    fileName,
                    fileSize,
                    type: 'netUrl',
                    fileUrl,
                    isCloud,
                    downloadContentId: fileUrl,
                    downloadId: fileUrl,
                }))) === null || _b === void 0 ? void 0 : _b.filter(n => {
                    const target = currentAttachments.find(c => c.id === n.id);
                    return !target;
                });
            }
        }
        if (diskType === 'cloudAtt') {
            attachments = (_c = selectedRows
                .map(item => {
                const { fileName, downloadUrl, identity, fileSize, expireTime } = item;
                return {
                    expired: expireTime,
                    downloadContentId: downloadUrl,
                    downloadId: downloadUrl,
                    fileName,
                    fileSize,
                    id: identity,
                    type: 'trs',
                    fileUrl: downloadUrl,
                    isCloud: addType === 'cloud',
                };
            })) === null || _c === void 0 ? void 0 : _c.filter(n => {
                const target = currentAttachments.find(c => c.id === n.id);
                return !target;
            });
        }
        if (diskType === 'normalAtt') {
            attachments = (_d = selectedRows
                .map(item => {
                const { partId, id, attn, attsize, rowId } = item;
                const downloadUrl = mailApi.mailContentHandler.buildAttachmentDownloadUrl({
                    _account: '',
                    filename: attn,
                    id: partId,
                }, id, true);
                return {
                    id: rowId,
                    expired: 0,
                    fileName: attn,
                    fileSize: attsize,
                    type: 'fromInternalMail',
                    midOfSourceMail: id,
                    partOfSourceMail: partId,
                    fileUrl: downloadUrl,
                    isCloud: addType === 'cloud',
                };
            })) === null || _d === void 0 ? void 0 : _d.filter(n => {
                const target = currentAttachments.find(c => c.id === n.id);
                return !target;
            });
        }
        if (!attachments || !attachments.length) {
            dispatch(diskSlice.actions.doToggleDiskModal(false));
            return;
        }
        mailApi
            .doAddAttachment(mailId, attachments, { usingCloud: addType === 'cloud' }, senderEmail)
            .then(res => {
            const attrs = attachments.map(({ fileName, fileUrl, fileSize, id, expired, type }) => ({
                mailId,
                fileUrl,
                size: fileSize,
                name: fileName,
                fileName,
                cloudAttachment: addType === 'cloud',
                type,
                id,
                expired,
            }));
            console.log('[attach reducer] add attachment:', attrs);
            dispatch(AttachmentActions.doAddAttachment(attrs));
            dispatch(diskSlice.actions.doToggleDiskModal(false));
            dispatch(MailActions.doChangeCacheAttachment({
                id: mailId,
                type: addType === 'cloud' ? 'diskCloudFile' : diskType === 'normalAtt' ? 'diskNormalFile' : 'diskFile',
                value: attachments,
                operationType: 'add',
            }));
        })
            .catch(error => {
            console.log('warn', error);
            dispatch(diskSlice.actions.doSetListLoading(false));
            dispatch(diskSlice.actions.doToggleDiskModal(false));
        });
    }
    catch (error) {
        const errorCode = get(error, ['data', 'code'], -1);
        if (errorCode == 10304) {
            message.error(getIn18Text('YUNFUJIANKONGJIAN12'));
        }
        else {
            message.error(getIn18Text('TIANJIAFUJIANSHI'));
        }
        dispatch(diskSlice.actions.doSetListLoading(false));
        return [];
    }
});
export const doAddCloudAttachment = createAsyncThunk('DiskReducer/doAddCloudAttachment', async (param, { dispatch, getState }) => {
    const rootState = getState();
    const currentMail = rootState.mailReducer.currentMail;
    const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
    try {
        const { mailId, fileDetail } = param;
        const payload = [fileDetail];
        mailApi
            .doAddAttachment(mailId, payload, { usingCloud: true }, senderEmail)
            .then(res => {
            if (res && res[0]) {
                const { fileName, fileSize, id, type, fileUrl, isCloud, expired } = fileDetail;
                dispatch(AttachmentActions.doAddAttachment([
                    {
                        mailId,
                        fileUrl,
                        size: fileSize,
                        name: fileName,
                        fileName,
                        cloudAttachment: isCloud,
                        type,
                        realId: res[0].realId,
                        id,
                        expired,
                    },
                ]));
            }
        })
            .catch(error => {
            console.log('warn', error);
        });
    }
    catch (error) {
        const errorCode = get(error, ['data', 'code'], -1);
        if (errorCode == 10304) {
            message.error(getIn18Text('YUNFUJIANKONGJIAN'));
        }
        else {
            message.error(getIn18Text('TIANJIAFUJIANSHI'));
        }
        return [];
    }
});
export const doAddNormalAttachment = createAsyncThunk('DiskReducer/doAddNormalAttachment', async (param, { dispatch, getState }) => {
    const rootState = getState();
    const currentMail = rootState.mailReducer.currentMail;
    const senderEmail = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
    try {
        const { mailId, fileDetail } = param;
        let payload = [];
        if (Array.isArray(fileDetail)) {
            payload = fileDetail;
        }
        else {
            payload = [fileDetail];
        }
        mailApi
            .doAddAttachment(mailId, payload, { usingCloud: false }, senderEmail)
            .then(res => {
            if (res === null || res === void 0 ? void 0 : res.length) {
                const atts = [];
                res.forEach(item => {
                    const { fileName, fileSize, type, fileUrl, isCloud, realId } = item;
                    atts.push({
                        mailId,
                        fileUrl,
                        size: fileSize,
                        name: fileName,
                        fileName,
                        cloudAttachment: isCloud,
                        type,
                        realId,
                        id: realId,
                    });
                });
                dispatch(AttachmentActions.doAddAttachment(atts));
            }
        })
            .catch(error => {
            console.log('doAddAttachment warn', error);
            return [];
        });
    }
    catch (error) {
        const errorCode = get(error, ['data', 'code'], -1);
        if (errorCode == 10304) {
            message.error(getIn18Text('YUNFUJIANKONGJIAN'));
        }
        else {
            message.error(getIn18Text('TIANJIAFUJIANSHI'));
        }
        return [];
    }
});
const resetNormalAttSt = () => {
    getNormalAttSt && clearTimeout(getNormalAttSt);
    reqNum = 0;
};
const diskSlice = createSlice({
    name: 'DiskReducer',
    initialState: InitialState,
    reducers: {
        doToggleDiskModal: (state, action) => {
            resetNormalAttSt();
            if (action.payload === false) {
                state.currentType = 'personal';
                state.listLoading = false;
                state.selectedRows = [];
            }
            state.diskModalVisible = action.payload;
        },
        doResetData: state => {
            state.rootInfo = InitialRootInfo;
            state.tabMsgs = InitialTabMsgs;
            state.curDirId = null;
            state.listLoading = false;
            state.currentType = 'personal';
            state.selectedRows = [];
            state.failMsgs = null;
            resetNormalAttSt();
        },
        doSetRootInfo: (state, action) => {
            state.rootInfo = action.payload;
        },
        doSetCurDirId: (state, action) => {
            state.curDirId = action.payload;
        },
        doSwitchType: (state, action) => {
            resetNormalAttSt();
            state.selectedRows = [];
            state.currentType = action.payload;
        },
        doSetSelectedKeys: (state, action) => {
            state.selectedRows = action.payload;
        },
        doSetPersonalLock: (state, action) => {
            const tabMsgs = state.tabMsgs;
            tabMsgs['personal'].isLocked = action.payload;
            state.tabMsgs = tabMsgs;
        },
        doSetListLoading: (state, action) => {
            state.listLoading = action.payload;
        },
        doUpdateTabMsg: (state, action) => {
            const { tab, val } = action.payload;
            const tabMsgs = state.tabMsgs;
            tabMsgs[tab] = Object.assign(Object.assign({}, state.tabMsgs[tab]), val);
            state.tabMsgs = tabMsgs;
        },
        doSetFailMsgs: (state, action) => {
            state.failMsgs = action.payload;
        },
    },
});
export const { actions } = diskSlice;
export default diskSlice.reducer;
